import { Button, SecondaryButton } from "../../components";
import { SuccessIcon } from "../../assets/svg";
import { useTranslation } from "react-i18next";
import { RootState } from "../../store/root-reducer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cleanUpClaim } from "../../store/mattress-claim/actions";

function SubmitClaim() {
  const { t } = useTranslation();
  const dipstach = useDispatch();
  const claim = useSelector((state: RootState) => state.claim);
  const CLAIM_STATUS_URL = `${process.env.REACT_APP_CLAIM_STATUS_URL}/${claim.status_code}`;
  const navigate = useNavigate();

  return (
    <div className="flex justify-center items-center h-[calc(100vh-72px)] ">
      {/* <BackButton
        text={t("Home")}
        onClick={() => {
          dispatch(cleanUpClaim());
          navigate("/");
        }}
      /> */}
      <div className="flex   flex-col items-center gap-8 px-2">
        <SuccessIcon size={98} />
        <span className="text-2xl font-semibold  text-center ">
          {t("Thank you for submitting your claim.")}
        </span>
        <div className="bg-[#F8F8F8] border-[#EDEDED] border p-3 flex flex-col items-center rounded-lg gap-1">
          <span className="text-[#505050] text-lg">{t("Claim Number")}</span>
          <span className="font-semibold text-4xl text-[#22222C]">
            {claim.name}
          </span>
        </div>
        {/* <span className="text-base text-[#696969] break-all text-center">
          {CLAIM_STATUS_URL}
        </span> */}

        <div className="space-y-3 w-full">
          <a
            href={CLAIM_STATUS_URL}
            target="_blank"
            rel="noreferrer"
            className="block w-full"
          >
            <Button className="">{t("Mattress Claim status page")}</Button>
          </a>
          <SecondaryButton
            onClick={() => {
              dipstach(cleanUpClaim());
              navigate("/");
            }}
          >
            {t("Back to Home")}
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
}

export default SubmitClaim;
